document.addEventListener("DOMContentLoaded", function() {
    function updateCountdown() {
        const targetDate = new Date("September 14, 2030 13:00:00").getTime();
        const now = new Date().getTime();
        const difference = targetDate - now;

        let days, hours, minutes, seconds;
        
        if (difference < 0) {
            // Si la diferencia es negativa, establecer todos los valores a 0
            days = 0;
            hours = 0;
            minutes = 0;
            seconds = 0;
        } else {
            // Calcular los días, horas, minutos y segundos restantes
            days = Math.floor(difference / (1000 * 60 * 60 * 24));
            hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            seconds = Math.floor((difference % (1000 * 60)) / 1000);
        }

        const daysElement = document.getElementById("days");
        const hoursElement = document.getElementById("hours");
        const minutesElement = document.getElementById("minutes");
        const secondsElement = document.getElementById("seconds");

        if (daysElement && hoursElement && minutesElement && secondsElement) {
            daysElement.textContent = days;
            hoursElement.textContent = hours;
            minutesElement.textContent = minutes;
            secondsElement.textContent = seconds;
        }
    }

    setInterval(updateCountdown, 1000);
    updateCountdown(); // Update countdown immediately on load
});

//-----------------------------------------  ------------------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    const checkbox1 = document.getElementById('cbx1');
    const checkbox2 = document.getElementById('cbx2');
    const btnRespuesta = document.querySelector('.btn_respuesta');

    if (checkbox1 && checkbox2 && btnRespuesta) {
        checkbox1.addEventListener('change', function() {
            if (checkbox1.checked) {
                checkbox2.checked = false;
            }
        });

        checkbox2.addEventListener('change', function() {
            if (checkbox2.checked) {
                checkbox1.checked = false;
            }
        });

        btnRespuesta.addEventListener('click', function() {
            if (checkbox1.checked) {
                window.location.href = 'https://wa.me/############?text=Le confirmo mi asistencia a la boda del 14 de Septiembre del 2024 a las 4pm, mi nombre es: ';
            } else if (checkbox2.checked) {
                window.location.href = 'https://wa.me/############?text=Lamento confirmar mi inasistencia a la boda del 14 de Septiembre del 2024 a las 4pm, mi nombre es: ';
            } else {
                alert('Debe seleccionar un campo de los dos');
            }
        });
    }
});

//-----------------------------------------  ------------------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    const galleryImages = document.querySelectorAll('.galeria_grid img');
    const lightbox = document.getElementById('lightbox');
    const lightboxImg = document.getElementById('lightbox-img');

    if (galleryImages.length && lightbox && lightboxImg) {
        galleryImages.forEach(img => {
            img.addEventListener('click', function() {
                openLightbox(this.src);
            });
        });

        function openLightbox(src) {
            lightbox.style.display = 'block';
            lightboxImg.src = src;
        }

        function closeLightbox() {
            lightbox.style.display = 'none';
        }

        lightbox.addEventListener('click', closeLightbox);
    }
});

//-----------------------------------------  ------------------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    const images = document.querySelectorAll('img');
    images.forEach(img => {
        img.setAttribute('loading', 'lazy');
    });
});
